var _defs, _rect, _polygon, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack365({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1.12,
    y: 2.75,
    width: 10.28,
    height: 4.61,
    transform: "translate(3.37 -2.45) rotate(30)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "11.04 7.82 13.19 11.54 15.34 7.82 11.04 7.82"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.08,15.27h-.5V11.35a2.87,2.87,0,0,1-.47.41,3.42,3.42,0,0,1-.54.33v-.6a3.22,3.22,0,0,0,.74-.58,2.46,2.46,0,0,0,.45-.67h.32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.15,12.55a1,1,0,0,1-.45-.39,1.15,1.15,0,0,1-.16-.64,1.33,1.33,0,0,1,.34-.93,1.08,1.08,0,0,1,.84-.35,1.11,1.11,0,0,1,.85.36,1.31,1.31,0,0,1,.34.94,1.19,1.19,0,0,1-.15.62,1.09,1.09,0,0,1-.45.39,1.11,1.11,0,0,1,.57.47,1.58,1.58,0,0,1,.2.82,1.55,1.55,0,0,1-.39,1.09,1.32,1.32,0,0,1-1.93,0,1.56,1.56,0,0,1-.38-1.11,1.5,1.5,0,0,1,.2-.83A1,1,0,0,1,5.15,12.55Zm-.26,1.27a1,1,0,0,0,.25.74.75.75,0,0,0,.59.29.77.77,0,0,0,.59-.28,1.23,1.23,0,0,0,0-1.47.76.76,0,0,0-1.18,0A1,1,0,0,0,4.89,13.82Zm.17-2.32a.84.84,0,0,0,.19.59.61.61,0,0,0,.48.22.59.59,0,0,0,.47-.22.77.77,0,0,0,.2-.55A.85.85,0,0,0,6.2,11a.66.66,0,0,0-.48-.22.58.58,0,0,0-.46.22A.76.76,0,0,0,5.06,11.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.57,12.8a4.23,4.23,0,0,1,.34-1.92,1.08,1.08,0,0,1,1-.64,1.06,1.06,0,0,1,.93.52,3.92,3.92,0,0,1,.41,2,4.16,4.16,0,0,1-.34,1.9,1.09,1.09,0,0,1-1,.65,1.12,1.12,0,0,1-1-.57A3.84,3.84,0,0,1,7.57,12.8Zm.51,0a3.71,3.71,0,0,0,.24,1.64.7.7,0,0,0,.6.42.68.68,0,0,0,.58-.42,4,4,0,0,0,.23-1.64,3.86,3.86,0,0,0-.23-1.63.7.7,0,0,0-.61-.42.66.66,0,0,0-.57.42A3.72,3.72,0,0,0,8.08,12.79Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack365);
export default __webpack_public_path__ + "static/media/Symbol_pack_365.266363f082ecd3eedae91a4adf42a036.svg";
export { ForwardRef as ReactComponent };